import React from 'react';
import { useSpecSheetField } from '../../../../../queries/useSpecSheetField';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

interface WindowsProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Windows: React.FC<WindowsProps> = ({ required, readOnly, propertyGuid, isReview = false }) => {
    const [windows, setWindows] = useSpecSheetField(
        propertyGuid,
        (s) => s.values?.['Exterior Features']?.['Windows'] ?? '',
        (s, v) => ({ ...s, values: { ...s.values, 'Exterior Features': { ...s.values?.['Exterior Features'], Windows: v } } })
    );
    const label = 'Windows';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={windows}
                />
            ) : (
                <TextBox
                    value={windows ?? ''}
                    onChange={(value) => setWindows(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
